<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Gg1jpW/images/more-fool-me.jpg?1733151169013" alt="This image is the cover for the book More Fool Me"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">More Fool Me
      </h1>
      <p class="bookDescription body article font2">
        <b>A woman embarks on a fresh start—but misplaced trust could end it all, in this knife’s-edge psychological thriller by the author of <i>The Desperate Wife</i>.</b><br/><br/> In the shadowy streets of Hull, Paige Carrigan tries to forage a brand-new life, but is still haunted by a past that refuses to stay buried. Orphaned and once entrapped by an abusive ex, but now eerily close to freedom, she finds solace in her writing and in a local group of people with secrets of their own.<br/><br/> But as Paige’s first proofreading client draws her into an enthralling yet unsettling romance, her fragile peace is shattered by a sinister text message: <i>You can run but you can’t hide.</i><br/><br/> With each new chapter she writes, the line between fiction and reality blurs—exposing a web of deceit spun by those she depends on most. Can Paige unmask the truth before her life mirrors her own tragic tales?<br/><br/> From the author of <i>Sunday’s Child</i> and <i>What’s Mine Is Yours</i>, <i>More Fool Me</i> is a gripping page-turner in which trust is a double-edged sword, and betrayal may be the only means of survival.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        C. L. Jennison
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4da02e69